import { render } from "./TemplateTextArea.vue?vue&type=template&id=fc0b57ae&scoped=true"
import script from "./TemplateTextArea.vue?vue&type=script&lang=js"
export * from "./TemplateTextArea.vue?vue&type=script&lang=js"

import "./TemplateTextArea.vue?vue&type=style&index=0&id=fc0b57ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0b57ae"]])

export default __exports__